import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { AlertService } from '../shared/services/alert.service';
import { Router } from '@angular/router';
import { FrontendDiagnosticsService } from './services/frontend-diagnostics.service';

@Injectable({
  providedIn: 'root',
})
export class CustomErrorHandler implements ErrorHandler {
  constructor(private alertService: AlertService, private injector: Injector) {}

  handleError(error: any): void {
    // Log the error to the console.
    console.error(error);

    // Push to diagnostics service so it can be included when user clicks "Send logs".
    try {
      const diagnosticsService = this.injector.get(FrontendDiagnosticsService);
      const message = error?.message || error?.Message || String(error);
      const stack = error?.stack;
      diagnosticsService.addError(message, stack);
    } catch (_) {
      // ignore if diagnostics service not available
    }

    // we wont be showing the error message for now, we have too many frontend small errors that can confuse the user. This custom handler was not working before. Once we have minimal frontend errors, we can show the error message again.
    /* this.alertService.error(
      error?.Message ||
        error?.message ||
        'An unexpected error occurred. Please try again later.'
    ); */
  }
}
